<!--
	These divs are intentionally hidden, and their only purpose is to allow SV testers to read
	the application version and client version from the HTML element.
-->

<div style="display: none" data-testid="sh-device-portal-app-version">{{ appVersion }}</div>
<div style="display: none" data-testid="sh-device-portal-client-version">{{ clientVersion }}</div>

<sh-elevated-access-main></sh-elevated-access-main>

@if (
	appUpdateService.state() === appUpdateStateEnum.InProgress ||
	appUpdateService.state() === appUpdateStateEnum.CompleteReloadRequired
) {
	<prism-banner data-testid="sh-app-banner" data-usable-height-contributor="true" *transloco="let t">
		<span [innerHTML]="t('cloud.device-management.app-update.read-only-message')"></span>
	</prism-banner>
}

<router-outlet></router-outlet>
